// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AylqH","content":"styles_content__2bAv7","row":"styles_row__3RYi6","footer":"styles_footer__v21uq","phraseLength":"styles_phraseLength__23Dhn"};